// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import ReactIdSwiper from "react-id-swiper";
import * as JsxPPXReactSupport from "rescript/lib/es6/jsxPPXReactSupport.js";
import * as LiveStream$LiveRoom from "../../stores/LiveStream.bs.js";
import * as Utils_Image$LiveRoom from "../../Utils/Utils_Image.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as LotThumbnail$LiveRoom from "./LotThumbnail.bs.js";
import * as Utils_Mobile$LiveRoom from "../../Utils/Utils_Mobile.bs.js";
import * as VindralPlayer$LiveRoom from "../../live-streaming/VindralPlayer.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as ResponsiveImage$LiveRoom from "../../ResponsiveImage.bs.js";
import * as StreamContainer$LiveRoom from "../../live-streaming/StreamContainer.bs.js";
import * as AnalyticsManager$LiveRoom from "../../analytics/AnalyticsManager.bs.js";
import * as LiveStreamThumbnail$LiveRoom from "./LiveStreamThumbnail.bs.js";

var swiperContainer = Curry._1(Css.style, {
      hd: Css.marginTop(Css.px(40)),
      tl: {
        hd: Css.media("(max-width:" + (StyleConstants$LiveRoom.tabletPortraitBreakpoint + ")"), {
              hd: Css.margin2(Css.px(16), "zero"),
              tl: {
                hd: Css.position("sticky"),
                tl: /* [] */0
              }
            }),
        tl: /* [] */0
      }
    });

var parentContainer = Curry._1(Css.style, {
      hd: Css.display(Css.flexBox),
      tl: {
        hd: Css.flexDirection(Css.column),
        tl: {
          hd: Css.media("print", {
                hd: Css.firstChild({
                      hd: Css.display(Css.block),
                      tl: /* [] */0
                    }),
                tl: {
                  hd: Css.children({
                        hd: Css.display(Css.none),
                        tl: /* [] */0
                      }),
                  tl: /* [] */0
                }
              }),
          tl: /* [] */0
        }
      }
    });

var printContainer = Curry._1(Css.style, {
      hd: Css.display(Css.none),
      tl: {
        hd: Css.media("print", {
              hd: Css.display(Css.block),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var printImage = Curry._1(Css.style, {
      hd: Css.maxWidth(Css.px(368)),
      tl: {
        hd: Css.maxHeight(Css.pct(100.0)),
        tl: {
          hd: Css.media("(max-width:" + (StyleConstants$LiveRoom.tabletPortraitBreakpoint + (") and (min-width:" + (StyleConstants$LiveRoom.mobileBreakpoint + ")"))), {
                hd: Css.maxHeight(Css.vh(30.0)),
                tl: /* [] */0
              }),
          tl: {
            hd: Css.media("(max-width:" + (StyleConstants$LiveRoom.mobileBreakpoint + ")"), {
                  hd: Css.maxHeight(Css.vh(20.0)),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var imageWrapper = Curry._1(Css.style, {
      hd: Css.width(Css.pct(100.0)),
      tl: {
        hd: Css.display(Css.flexBox),
        tl: {
          hd: Css.justifyContent(Css.center),
          tl: /* [] */0
        }
      }
    });

var heroImageContainer = Curry._1(Css.style, {
      hd: Css.maxHeight(Css.px(480)),
      tl: {
        hd: Css.position(Css.relative),
        tl: {
          hd: Css.width(Css.pct(100.0)),
          tl: {
            hd: Css.before({
                  hd: Css.unsafe("content", "\"\""),
                  tl: {
                    hd: Css.display(Css.block),
                    tl: {
                      hd: Css.paddingTop(Css.px(480)),
                      tl: {
                        hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                              hd: Css.paddingTop(Css.vh(30.0)),
                              tl: /* [] */0
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }),
            tl: {
              hd: Css.media("(max-width:" + (StyleConstants$LiveRoom.tabletPortraitBreakpoint + (") and (min-width:" + (StyleConstants$LiveRoom.mobileBreakpoint + ")"))), {
                    hd: Css.maxHeight(Css.vh(30.0)),
                    tl: /* [] */0
                  }),
              tl: {
                hd: Css.media("(max-width:" + (StyleConstants$LiveRoom.mobileBreakpoint + ")"), {
                      hd: Css.maxHeight(Css.vh(20.0)),
                      tl: /* [] */0
                    }),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var heroImageWrapper = Curry._1(Css.style, {
      hd: Css.position(Css.absolute),
      tl: {
        hd: Css.top(Css.zero),
        tl: {
          hd: Css.left(Css.px(16)),
          tl: {
            hd: Css.right(Css.px(16)),
            tl: {
              hd: Css.bottom(Css.zero),
              tl: {
                hd: Css.display(Css.flexBox),
                tl: {
                  hd: Css.justifyContent(Css.center),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var heroInnerImageWrapper = Curry._1(Css.style, {
      hd: Css.display(Css.flexBox),
      tl: {
        hd: Css.alignItems(Css.center),
        tl: {
          hd: Css.justifyContent(Css.center),
          tl: /* [] */0
        }
      }
    });

var heroImage = Curry._1(Css.style, {
      hd: Css.label("heroImage"),
      tl: {
        hd: Css.maxHeight(Css.px(480)),
        tl: {
          hd: Css.marginLeft("auto"),
          tl: {
            hd: Css.marginRight("auto"),
            tl: {
              hd: Css.maxWidth(Css.pct(100.0)),
              tl: {
                hd: Css.height(Css.pct(100)),
                tl: {
                  hd: Css.width(Css.pct(100)),
                  tl: {
                    hd: Css.unsafe("objectFit", "contain"),
                    tl: {
                      hd: Css.transition(StyleConstants$LiveRoom.animationFast, undefined, undefined, "opacity"),
                      tl: {
                        hd: Css.opacity(1),
                        tl: {
                          hd: Css.media("(max-width:" + (StyleConstants$LiveRoom.tabletPortraitBreakpoint + (") and (min-width:" + (StyleConstants$LiveRoom.mobileBreakpoint + ")"))), {
                                hd: Css.maxHeight(Css.vh(30.0)),
                                tl: /* [] */0
                              }),
                          tl: {
                            hd: Css.media("(max-width:" + (StyleConstants$LiveRoom.mobileBreakpoint + ")"), {
                                  hd: Css.maxHeight(Css.vh(20.0)),
                                  tl: /* [] */0
                                }),
                            tl: {
                              hd: Css.media("print", {
                                    hd: Css.maxWidth(Css.px(368)),
                                    tl: {
                                      hd: Css.maxHeight(Css.pct(100)),
                                      tl: {
                                        hd: Css.borderColor(Css.hex("ff0000")),
                                        tl: {
                                          hd: Css.borderStyle(Css.solid),
                                          tl: {
                                            hd: Css.borderWidth(Css.px(1)),
                                            tl: /* [] */0
                                          }
                                        }
                                      }
                                    }
                                  }),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var heroImageHidden = Curry._1(Css.style, {
      hd: Css.label("heroImageHidden"),
      tl: {
        hd: Css.opacity(0),
        tl: {
          hd: Css.transition(StyleConstants$LiveRoom.animationFast, undefined, undefined, "opacity"),
          tl: /* [] */0
        }
      }
    });

function isSelected(index, selectedItem) {
  return index === selectedItem;
}

function carouselItems(media, selectedItem, isStreamPresent, isHDvideo, streamSelected, onImageSelected, onStreamSelected, lotTitle) {
  return Belt_Array.concat(isStreamPresent && isHDvideo ? [React.createElement("div", {
                      key: "liveStreamThumbnail"
                    }, React.createElement(LiveStreamThumbnail$LiveRoom.make, {
                          onClick: (function (param) {
                              Curry._1(onStreamSelected, undefined);
                            }),
                          isSelected: streamSelected
                        }))] : [], Belt_Array.mapWithIndex(Utils_Image$LiveRoom.getAllRenditions(media), (function (index, imageRenditions) {
                    var match = Belt_Array.get(imageRenditions, 0);
                    return React.createElement("div", {
                                key: lotTitle + (String(index) + "swiper")
                              }, JsxPPXReactSupport.createElementWithKey((
                                    match !== undefined ? match.url : "NoImage"
                                  ) + "-LotThumbnail", LotThumbnail$LiveRoom.make, {
                                    imageRenditions: imageRenditions,
                                    onImageSelected: onImageSelected,
                                    index: index,
                                    isSelected: !streamSelected && index === selectedItem,
                                    lotTitle: lotTitle,
                                    sizes: {
                                      responsiveWidths: undefined,
                                      default: {
                                        NAME: "px",
                                        VAL: 88
                                      }
                                    }
                                  }));
                  })));
}

function LotCarousel(props) {
  var isMobile = props.isMobile;
  var lot = props.lot;
  var me = props.me;
  var isMobile$1 = isMobile !== undefined ? isMobile : false;
  var imageRef = React.useRef(null);
  var match = Curry._1(LiveStream$LiveRoom.Context.use, undefined);
  var dispatchLiveStream = match[1];
  var liveStreamState = match[0];
  var isTouchDevice = React.useMemo(function () {
        return Utils_Mobile$LiveRoom.isTouchDevice(undefined);
      });
  var media = lot.media;
  var lotTitle = lot.title;
  var match$1 = React.useReducer((function (state, action) {
          if (typeof action === "number") {
            if (action !== 0) {
              return {
                      selectedItem: 0,
                      imageRenditions: Utils_Image$LiveRoom.getRenditions(media, 0),
                      showThumbnails: false
                    };
            } else {
              return {
                      selectedItem: state.selectedItem,
                      imageRenditions: state.imageRenditions,
                      showThumbnails: state.imageRenditions.length > 1
                    };
            }
          }
          var index = action._0;
          AnalyticsManager$LiveRoom.auctionRoomInteraction(me, "ClickAlternativeImage");
          return {
                  selectedItem: index,
                  imageRenditions: Utils_Image$LiveRoom.getRenditions(media, index),
                  showThumbnails: state.showThumbnails
                };
        }), {
        selectedItem: 0,
        imageRenditions: Utils_Image$LiveRoom.getRenditions(media, 0),
        showThumbnails: true
      });
  var dispatch = match$1[1];
  var state = match$1[0];
  var floatingStreamContainerHeight = function (height) {
    if (liveStreamState.position === /* Floating */0) {
      return Curry._1(dispatchLiveStream, /* SetFloatingStreamContainerHeight */{
                  _0: height
                });
    } else {
      return Curry._1(dispatchLiveStream, /* SetFloatingStreamContainerHeight */{
                  _0: 0
                });
    }
  };
  var match$2 = lot.session;
  var match$3;
  if (match$2 !== undefined) {
    var match$4 = match$2.stream;
    if (match$4 !== undefined) {
      var match$5 = match$4.streamData;
      if (typeof match$5 === "object" && match$5.NAME === "MediaStreamVindral") {
        var match$6 = match$5.VAL;
        match$3 = [
          Caml_option.some(React.createElement(StreamContainer$LiveRoom.make, {
                    showStream: liveStreamState.position !== /* Closed */2,
                    floatStream: liveStreamState.position === /* Floating */0,
                    getContainerHeight: floatingStreamContainerHeight,
                    children: React.createElement(VindralPlayer$LiveRoom.make, {
                          url: match$6.streamUrl,
                          channelId: match$6.streamId,
                          auctionId: lot.auction.auctionId,
                          sessionId: match$2.sessionId,
                          onClose: (function (param) {
                              Curry._1(dispatchLiveStream, /* CloseStream */2);
                            }),
                          onOpen: (function (param) {
                              Curry._1(dispatchLiveStream, isMobile$1 ? /* CenterStream */1 : /* ShowStream */3);
                            }),
                          pinStream: liveStreamState.position === /* Floating */0 || liveStreamState.position === /* Closed */2,
                          showStream: liveStreamState.position !== /* Closed */2
                        })
                  })),
          true
        ];
      } else {
        match$3 = [
          undefined,
          false
        ];
      }
    } else {
      match$3 = [
        undefined,
        false
      ];
    }
  } else {
    match$3 = [
      undefined,
      false
    ];
  }
  var stream = match$3[0];
  React.useEffect((function () {
          Curry._1(dispatch, /* ResetState */1);
        }), [lot.lotId]);
  React.useEffect((function () {
          Curry._1(dispatch, /* ShowThumbnails */0);
        }), [state.imageRenditions]);
  React.useEffect((function () {
          if (isMobile$1 && Belt_Option.isSome(stream)) {
            Curry._1(dispatchLiveStream, /* CenterStream */1);
          }
          
        }), []);
  var tmp;
  if (liveStreamState.position !== /* FrontAndCenter */1) {
    var match$7 = Belt_Array.get(state.imageRenditions, 0);
    tmp = React.createElement("div", {
          className: imageWrapper + " col-sm-12 col-md-12 col-lg-12"
        }, React.createElement("div", {
              className: heroImageContainer
            }, React.createElement("div", {
                  className: heroImageWrapper
                }, React.createElement("div", {
                      className: heroInnerImageWrapper
                    }, JsxPPXReactSupport.createElementWithKey("AuctionRoomLotCarousel" + (
                          match$7 !== undefined ? match$7.url + ("-" + String(state.selectedItem)) : "NoImage"
                        ), ResponsiveImage$LiveRoom.make, {
                          imageRenditions: state.imageRenditions,
                          alt: lotTitle,
                          sizes: {
                            responsiveWidths: undefined,
                            default: {
                              NAME: "px",
                              VAL: 800
                            }
                          },
                          setRef: imageRef,
                          className: heroImageHidden,
                          onLoad: (function (param) {
                              var r = imageRef.current;
                              if (!(r == null)) {
                                r.className = heroImage;
                                return ;
                              }
                              
                            })
                        })))));
  } else {
    tmp = null;
  }
  return React.createElement("div", {
              className: parentContainer
            }, React.createElement("div", {
                  className: printContainer
                }, React.createElement(ResponsiveImage$LiveRoom.make, {
                      imageRenditions: state.imageRenditions,
                      alt: "",
                      sizes: {
                        responsiveWidths: undefined,
                        default: {
                          NAME: "px",
                          VAL: 368
                        }
                      },
                      className: printImage
                    })), Belt_Option.getWithDefault(stream, null), tmp, state.showThumbnails ? React.createElement("div", {
                    className: swiperContainer
                  }, JsxPPXReactSupport.createElementWithKey(lotTitle + "-LotCarouselSwiperWrapper", ReactIdSwiper, {
                        containerClass: Curry._1(Css.style, {
                              hd: Css.selector(".swiper-wrapper > .swiper-slide, .swiper-wrapper > .swiper-slide > button", {
                                    hd: Css.width(Css.px(50)),
                                    tl: {
                                      hd: Css.height(Css.px(50)),
                                      tl: {
                                        hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                              hd: Css.width(Css.px(40)),
                                              tl: {
                                                hd: Css.height(Css.px(40)),
                                                tl: /* [] */0
                                              }
                                            }),
                                        tl: /* [] */0
                                      }
                                    }
                                  }),
                              tl: /* [] */0
                            }),
                        slidesPerView: "auto",
                        spaceBetween: 8,
                        mousewheel: true,
                        centerInsufficientSlides: false,
                        navigation: {
                          nextEl: isTouchDevice ? "" : ".swiper-button-next",
                          prevEl: isTouchDevice ? "" : ".swiper-button-prev"
                        },
                        threshold: 10,
                        shouldSwiperUpdate: true,
                        renderPrevButton: (function (param) {
                            return null;
                          }),
                        renderNextButton: (function (param) {
                            return null;
                          }),
                        children: carouselItems(media, state.selectedItem, Belt_Option.isSome(stream), match$3[1], liveStreamState.position === /* FrontAndCenter */1, (function (index) {
                                if (index !== state.selectedItem) {
                                  var r = imageRef.current;
                                  if (!(r == null)) {
                                    r.className = heroImageHidden;
                                  }
                                  
                                }
                                Curry._1(dispatch, /* SetSelectedItem */{
                                      _0: index
                                    });
                                if (liveStreamState.position === /* FrontAndCenter */1) {
                                  return Curry._1(dispatchLiveStream, isMobile$1 ? /* CloseStream */2 : /* FloatStream */0);
                                }
                                
                              }), (function (param) {
                                Curry._1(dispatchLiveStream, /* CenterStream */1);
                              }), lotTitle)
                      })) : null);
}

var make = LotCarousel;

export {
  swiperContainer ,
  parentContainer ,
  printContainer ,
  printImage ,
  imageWrapper ,
  heroImageContainer ,
  heroImageWrapper ,
  heroInnerImageWrapper ,
  heroImage ,
  heroImageHidden ,
  isSelected ,
  carouselItems ,
  make ,
}
/* swiperContainer Not a pure module */
